export const featureKeys = [
  'clickEvent',
  'hotspotStyling',
  'fullDiscussion',
];
export const discussionCommentPageSize = 10;
export const discussionRepliesPageSize = 5;
export const commentPopulationDebounceLimitInSeconds = 5;
export const interactionTypeData = {
  multiple_choice: {
    value: 'multiple_choice',
    label: 'Multiple choice',
    icon: 'format_list_bulleted',
    group: 'questions',
    helpscout_id: 'multiplechoice',
  },
  check_all_apply: {
    value: 'check_all_apply',
    label: 'Check all',
    icon: 'playlist_add_check',
    group: 'questions',
    helpscout_id: 'checkall',
  },
  free_response: {
    value: 'free_response',
    label: 'Free response',
    icon: 'border_color',
    group: 'questions',
    helpscout_id: 'freeresponse',
  },
  short_answer: {
    value: 'short_answer',
    label: 'Fill in the blank',
    icon: 'subtitles',
    group: 'questions',
    helpscout_id: 'fillblank',
  },
  pause_q: {
    value: 'pause_q',
    label: 'Pause',
    icon: 'bookmark_border',
    group: 'annotations',
    helpscout_id: 'reflectivepause',
  },
  iframe_q: {
    value: 'iframe_q',
    label: 'Embedded',
    icon: 'public',
    group: 'annotations',
    helpscout_id: 'webembed',
  },
  file_viewer_q: {
    value: 'fiew_viewer_q',
    label: 'PDF File',
    icon: 'picture_as_pdf',
    group: 'annotations',
    helpscout_id: 'fileembed',
  },
  poll_q: {
    value: 'poll_q',
    label: 'Poll',
    icon: 'poll',
    group: 'questions',
    helpscout_id: 'pollingsurvey',
  },
  discussion_q: {
    value: 'discussion_q',
    label: 'Discussion',
    icon: 'chat',
    group: 'questions',
    helpscout_id: 'discussionforum',
  },
};
export default {
  featureKeys,
  discussionCommentPageSize,
  discussionRepliesPageSize,
  commentPopulationDebounceLimitInSeconds,
  interactionTypeData,
};